import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { UserManagementService } from '../../core/services/user-management.service';
import { UserManagementDto } from '../../core/models/user-management.dto';
import { UserRole } from '../../core/enums/user-role.enum';

const isBrowser = typeof localStorage !== 'undefined';

@Component({
  selector: 'app-user-onboarding',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './user-onboarding.html',
  styleUrl: './user-onboarding.scss',
})
export class UserOnboarding implements OnInit {
  users: UserManagementDto[] = [];
  isLoading = false;

  constructor(
    private router: Router,
    private userManagementService: UserManagementService,
  ) {}

  ngOnInit(): void {
    this.loadUsers();
  }

  private loadUsers(): void {
    this.isLoading = true;
    this.userManagementService.getClinicUsers().subscribe({
      next: (users) => {
        this.users = users;
        this.isLoading = false;
      },
      error: () => {
        this.users = [];
        this.isLoading = false;
      },
    });
  }

  get activeDoctorCount(): number {
    return this.users.filter((u) => this.normalizeRole(u.role) === UserRole.DOCTOR && u.active)
      .length;
  }

  get doctorCapReached(): boolean {
    return this.activeDoctorCount >= 3;
  }

  get activeReceptionistCount(): number {
    return this.users.filter((u) => this.normalizeRole(u.role) === UserRole.RECEPTION && u.active)
      .length;
  }

  get receptionistCapReached(): boolean {
    return this.activeReceptionistCount >= 5;
  }

  private normalizeRole(role: string): UserRole {
    const normalized = (role || '').toUpperCase();
    if (normalized === UserRole.DOCTOR) return UserRole.DOCTOR;
    if (normalized === UserRole.MANAGER) return UserRole.MANAGER;
    return UserRole.RECEPTION;
  }

  goToInviteDoctor(): void {
    if (!this.doctorCapReached) {
      this.router.navigate(['dashboard/invite-doctor']);
    }
  }

  goToOnboardUsers(): void {
    if (!this.receptionistCapReached) {
      this.router.navigate(['dashboard/create-clinic-employee']);
    }
  }
}
